export default {"src":"/frontend-static/_next/static/media/tshirt.7f0880d0.svg","height":216,"width":203,"blurWidth":0,"blurHeight":0};